import React, { useState } from "react";
import "./ContactUs.css";

import type { SyntheticEvent } from "react";

import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

import { submitContactUs } from "../../services/contactUsApi";

import phoneIcon from "../../assets/images/Group 1000000863.svg";
import mailIcon from "../../assets/images/Group 1000001129@2x.png";
import locationIcon from "../../assets/images/Group 1000000865.svg";

const ContactUs: React.FC = () => {
  const [popup, setPopup] = useState({
  open: false,
  message: "",
  type: "", // success | error
});

const [formData, setFormData] = useState({
  name: "",
  email: "",
  phone: "",
  subject: "",
  message: "",
});

const [errors, setErrors] = useState({
  name: "",
  email: "",
  phone: "",
  subject: "",
  message: "",
});

const [loading, setLoading] = useState(false);

const handleChange = (
  e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));

  setErrors((prev) => ({
    ...prev,
    [name]: "",
  }));
};

const validateForm = () => {
  const newErrors = {
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  };

  let isValid = true;

  // Name
  if (!formData.name.trim()) {
    newErrors.name = "Name is required";
    isValid = false;
  }

  // Email
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!formData.email.trim()) {
    newErrors.email = "Email is required";
    isValid = false;
  } else if (!emailRegex.test(formData.email)) {
    newErrors.email = "Enter a valid email";
    isValid = false;
  }

  // Phone
  const phoneRegex = /^[6-9]\d{9}$/;

  if (!formData.phone.trim()) {
    newErrors.phone = "Phone number is required";
    isValid = false;
  } else if (!phoneRegex.test(formData.phone)) {
    newErrors.phone = "Enter a valid 10-digit phone number";
    isValid = false;
  }

  // Subject
  if (!formData.subject.trim()) {
    newErrors.subject = "Subject is required";
    isValid = false;
  }

  // Message
  if (!formData.message.trim()) {
    newErrors.message = "Message is required";
    isValid = false;
  }

  setErrors(newErrors);

  return isValid;
};

const handleSubmit = async (e: SyntheticEvent<HTMLFormElement>) => {
  e.preventDefault();

  if (!validateForm()) return;

  setLoading(true);

  try {
    const result = await submitContactUs({
      name: formData.name,
      emailId: formData.email,
      phone: formData.phone,
      subject: formData.subject,
      message: formData.message,
    });

    if (result.success) {
      const response = result.data;

      if (response.errorMessage) {
  setPopup({
    open: true,
    message: response.errorMessage,
    type: "error",
  });
} else {
        setPopup({
  open: true,
  message:
    response.successMessage ||
    "Thank you! Your message has been sent.",
  type: "success",
});

        setFormData({
          name: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
        });
      }
    } else {
      setPopup({
  open: true,
  message: "Something went wrong. Please try again.",
  type: "error",
});
    }
  } catch (error) {
    console.error(error);
    alert("Something went wrong. Please try again.");
  } finally {
    setLoading(false);
  }
};



  return (
    <>

<title>Contact Finsall for Premium Finance Support</title>
<meta
  name="description"
  content="Reach Finsall for queries on premium finance, insurance EMI, partner onboarding or customer support through our dedicated communication channels."
/>

      <Header />

      <section className="contact-top-strip"></section>

      <section className="contact-section">

        <div className="contact-container">

          {/* LEFT SIDE */}

          <div className="contact-form-column">

            <h2 className="contact-heading">
              Get in touch with us
            </h2>

            <form className="contact-form" onSubmit={handleSubmit}>

              <input
  type="text"
  name="name"
  placeholder="Your Name"
  value={formData.name}
  onChange={handleChange}
/>

{errors.name && (
  <span className="error-text">{errors.name}</span>
)}

              <input
  type="email"
  name="email"
  placeholder="Email"
  value={formData.email}
  onChange={handleChange}
/>

{errors.email && (
  <span className="error-text">{errors.email}</span>
)}

              <input
  type="tel"
  name="phone"
  placeholder="Phone"
  value={formData.phone}
  onChange={handleChange}
/>

{errors.phone && (
  <span className="error-text">{errors.phone}</span>
)}

              <input
  type="text"
  name="subject"
  placeholder="Subject"
  value={formData.subject}
  onChange={handleChange}
/>

{errors.subject && (
  <span className="error-text">{errors.subject}</span>
)}

              <textarea
  name="message"
  placeholder="Message"
  rows={5}
  value={formData.message}
  onChange={handleChange}
/>

{errors.message && (
  <span className="error-text">{errors.message}</span>
)}

              <div className="contact-btn-wrapper">

                <button
  type="submit"
  className="contact-submit-btn"
  disabled={loading}
>
  {loading ? "Sending..." : "Send Message"}
</button>

              </div>

            </form>

          </div>

          {/* RIGHT SIDE */}

          <div className="contact-info-column">

            <h2 className="contact-trust-heading">

              <span>Trusted</span> by Insurers
              <br />
              <span>Loved</span> by Customers

            </h2>

            <h3 className="contact-impact">

              <span>8,30,000+</span>
              {" "}
              Lives Impacted

            </h3>

            <div className="contact-info-list">

              <div className="contact-info-item">

                <img
                  src={phoneIcon}
                  alt="Phone support icon"
                />

                <div>

                  <h4>Contact Us:</h4>

                  <p>18005705797</p>

                  <p>
                    Monday to Saturday
                    <br />
                    9:30 AM to 7:00 PM
                  </p>

                </div>

              </div>

              <div className="contact-info-item">

                <img
                  src={mailIcon}
                  alt="email contact icon"
                />

                <div>

                  <p>
                    support@finsall.com
                  </p>

                </div>

              </div>

              <div className="contact-info-item address-item">

                <img
                  src={locationIcon}
                  alt="office location icon"
                />

                <div>

                  <p>
                    Finsall Resources Pvt. Ltd.,
                    <br />
                    365 Shared space,
                    Third Floor,
                    No. 379,
                    5th Main Road,
                    <br />
                    Sector 6,
                    HSR Layout,
                    Bengaluru,
                    Karnataka 560102
                  </p>

                </div>

              </div>

            </div>

          </div>

        </div>

      </section>

      <Footer />

{popup.open && (
  <div className="popup-overlay">
    <div className="popup-modal">
      <div className={`popup-icon ${popup.type}`}>
  {popup.type === "success" ? "✓" : "✕"}
</div>
      <h3>
        {popup.type === "success"
          ? "Success"
          : "Error"}
      </h3>

      <p>{popup.message}</p>

      <button
        onClick={() =>
          setPopup({
            open: false,
            message: "",
            type: "",
          })
        }
      >
        OK
      </button>
    </div>
  </div>
)}

    </>
  );
};

export default ContactUs;